const SearchUserSection = ({ handleSetUser, handleShowReport }) => (
  <div className='flex justify-between items-center'>
    <span></span>
    <div className='px-3'>
      <div className='flex gap-2'>
        <input
          className='block px-3 py-2 border bg-transparent border-gray-300 rounded-md text-sm shadow-sm focus:outline-none focus:ring-1 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none'
          type='number'
          // value={userId}
          placeholder='Enter user id'
          onChange={handleSetUser}
        />
        <button
          onClick={handleShowReport}
          className='border border-gray-300 border-2 rounded px-2'>
          Show report
        </button>
      </div>
    </div>
  </div>
)

export default SearchUserSection